import { VALIDGUESSES } from '../constants/validGuesses'
import { WORDS } from '../constants/wordlist'

export const isWordInWordList = (word: string) => {
  const lowercaseWord = word.toLowerCase()
  return (
    solution.toLowerCase() === lowercaseWord ||
    VALIDGUESSES.some((w) => w.toLowerCase() === lowercaseWord)
  )
}

export const isWinningWord = (word: string) => {
  return solution === word
}

export const getWordOfDay = () => {
  // January 1, 2022 Game Epoch
  const epochMs = 1640995200000 - 3600000
  const now = Date.now()
  const msInDay = 86400000
  const index = Math.floor((now - epochMs) / msInDay)
  const nextday = (index + 1) * msInDay + epochMs

  return {
    solution: WORDS[index % WORDS.length].toUpperCase(),
    solutionIndex: index,
    tomorrow: nextday,
  }
}

export const { solution, solutionIndex, tomorrow } = getWordOfDay()
